import { MarketplaceProductType } from 'shared/@generated/models';

export const ProductType = MarketplaceProductType;
export type ProductType = MarketplaceProductType;

export interface MarketplaceProduct {
  product_type: MarketplaceProductType;
  name: string;
  localized_price: {
    amount_minor: number;
    currency: string;
  };
  duration: {
    y: number;
    m: number;
    d: number;
    h: number;
    i: number;
    s: number;
  };
  data: Record<string, number>;
}
